import { render } from "./convertGame.vue?vue&type=template&id=548294db&scoped=true"
import script from "./convertGame.vue?vue&type=script&lang=js"
export * from "./convertGame.vue?vue&type=script&lang=js"

import "./convertGame.vue?vue&type=style&index=0&id=548294db&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548294db"]])

export default __exports__